import { useEffect, useState } from "react";
import type { CreativeItem } from "@digital-twins/shared-types";
import { creativeLibraryApi } from "@/lib/api/creative-library";
import { PrivateImage } from "@/pages/KnowledgeHubPage/creatives/PrivateImage";
import type { QuoteReferencePreviewsProps } from "@/types/components/thread-image-approval";

/** Owner-only quote tokens are reauthorized by the Library, never public image URLs. */
export function QuoteReferencePreviews({
  tokens,
}: QuoteReferencePreviewsProps) {
  const [images, setImages] = useState<CreativeItem[]>([]);
  const key = JSON.stringify(tokens);
  useEffect(() => {
    let current = true;
    setImages([]);
    const ids: string[] = JSON.parse(key);
    if (!ids.length)
      return () => {
        current = false;
      };
    void Promise.allSettled(
      ids.map((token) => creativeLibraryApi.creative(token)),
    ).then((results) => {
      if (current)
        setImages(
          results.flatMap((result) =>
            result.status === "fulfilled" ? [result.value] : [],
          ),
        );
    });
    return () => {
      current = false;
    };
  }, [key]);
  if (!images.length) return null;
  return (
    <div
      className="flex flex-wrap gap-2 pt-1"
      data-testid="image-quote-references"
    >
      {images.map((image) => (
        <PrivateImage
          key={image.token}
          source={image.mediaUrl}
          alt={image.title}
          className="h-12 w-12 rounded-md border border-border bg-background object-contain"
        />
      ))}
    </div>
  );
}
